function Footer() {
  return (
    <footer className="bg-[#404040] shadow-[inset_0_0_30px_0_#000]">
      <div className="layout-positioner text-[#ffffff] flex-1 py-[20px]">
        Powered By Art Institute of Chicago API. Designed by Kazoli.
      </div>
    </footer>
  );
}

export default Footer;
